import { z } from 'zod';
import { TextBlockSchema } from '$lib/sanity/schemas/components/Text';

export const QuantitativeItemSchema = z.object({
  primaryCategory: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  secondaryCategory: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  tertiaryCategory: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  value: z.number()
});

export type QuantitativeItem = z.infer<typeof QuantitativeItemSchema>;

export const ChartQuantitativeSchema = z.object({
  _id: z.string(),
  alt: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  colorTheme: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  chart: z.object({
    items: z.array(QuantitativeItemSchema).optional()
  }),
  displayAxisLabels: z
    .boolean()
    .nullish()
    .transform((x) => x ?? true),
  footnote: z.array(TextBlockSchema).optional(),
  headline: z.string(),
  legendDisplay: z.string(),
  prefix: z.string().optional(),
  subhead: z.string().optional(),
  suffix: z.string().optional()
});

export type ChartQuantitative = z.infer<typeof ChartQuantitativeSchema>;

export const GeospatialItemSchema = z.object({
  additional: z.string().optional(),
  country: z.string(),
  lat: z.string().optional(),
  long: z.string().optional(),
  primaryCategory: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  secondaryCategory: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  tertiaryCategory: z
    .string()
    .nullish()
    .transform((x) => x ?? '')
});

export type GeospatialItem = z.infer<typeof GeospatialItemSchema>;

export const ChartGeospatialSchema = ChartQuantitativeSchema.omit({
  chart: true,
  legendDisplay: true,
  suffix: true
}).extend({
  chart: z.object({
    items: z.array(GeospatialItemSchema).optional()
  })
});

export type ChartGeospatial = z.infer<typeof ChartGeospatialSchema>;
